import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
import * as apiSysMngt from 'apiSaga/apiSystemMngt';
import createRequestSaga from 'apiSaga/createRequestSaga';

/***** 액션 타입 선언 *****/

// 0. Response 초기화
const INIT_SYSTEM_MNGT_RESP = 'sysMngt/INIT_SYSTEM_MNGT_RESP';
const INIT_ERROR_HANDLING_LIST_RESP = 'sysMngt/INIT_ERROR_HANDLING_LIST_RESP';
const INIT_ERROR_HANDLING_DETAIL_VIEW_RESP = 'sysMngt/INIT_ERROR_HANDLING_DETAIL_VIEW_RESP';
const INIT_COMPANY_LIST_RESP = 'sysMngt/INIT_COMPANY_LIST_RESP';
const INIT_INSERT_CUSTOM_IP_INFO_RESP = 'sysMngt/INIT_INSERT_CUSTOM_IP_INFO_RESP';
const INIT_SAVE_CUSTOM_SYS_INFO_RESP = 'sysMngt/INIT_SAVE_CUSTOM_SYS_INFO_RESP';
const INIT_OS_IP_DETAIL_RESP = 'sysMngt/INIT_OS_IP_DETAIL_RESP';
const INIT_SERVICE_NM_LIST_RESP = 'sysMngt/INIT_SERVICE_NM_LIST_RESP';
const INIT_DOC_NM_LIST_RESP = 'sysMngt/INIT_DOC_NM_LIST_RESP';
const INIT_EXCEL_ERROR_HANDLING_LIST_RESP = 'sysMngt/INIT_EXCEL_ERROR_HANDLING_LIST_RESP';

// U009.  오류 처리 현황 게시판 리스트
const GET_ERROR_HANDLING_LIST = 'sysMngt/GET_ERROR_HANDLING_LIST';
const GET_ERROR_HANDLING_LIST_SUCCESS = 'sysMngt/GET_ERROR_HANDLING_LIST_SUCCESS';
const GET_ERROR_HANDLING_LIST_FAILURE = 'sysMngt/GET_ERROR_HANDLING_LIST_FAILURE';
// U010. 오류 처리 현황 게시판 상세보기
const GET_ERROR_HANDLING_DETAIL_VIEW = 'sysMngt/GET_ERROR_HANDLING_DETAIL_VIEW';
const GET_ERROR_HANDLING_DETAIL_VIEW_SUCCESS = 'sysMngt/GET_ERROR_HANDLING_DETAIL_VIEW_SUCCESS';
const GET_ERROR_HANDLING_DETAIL_VIEW_FAILURE = 'sysMngt/GET_ERROR_HANDLING_DETAIL_VIEW_FAILURE';
// U011. 이용중인 (유통사) 서비스 리스트
const GET_COMPANY_LIST = 'sysMngt/GET_COMPANY_LIST';
const GET_COMPANY_LIST_SUCCESS = 'sysMngt/GET_COMPANY_LIST_SUCCESS';
const GET_COMPANY_LIST_FAILURE = 'sysMngt/GET_COMPANY_LIST_FAILURE';
// U012. 시스템 등록
const INSERT_CUSTOM_IP_INFO = 'sysMngt/INSERT_CUSTOM_IP_INFO';
const INSERT_CUSTOM_IP_INFO_SUCCESS = 'sysMngt/INSERT_CUSTOM_IP_INFO_SUCCESS';
const INSERT_CUSTOM_IP_INFO_FAILURE = 'sysMngt/INSERT_CUSTOM_IP_INFO_FAILURE';
// U013. 시스템 수정(등록 , 수정, 삭제)
const SAVE_CUSTOM_SYS_INFO = 'sysMngt/SAVE_CUSTOM_SYS_INFO';
const SAVE_CUSTOM_SYS_INFO_SUCCESS = 'sysMngt/SAVE_CUSTOM_SYS_INFO_SUCCESS';
const SAVE_CUSTOM_SYS_INFO_FAILURE = 'sysMngt/SAVE_CUSTOM_SYS_INFO_FAILURE';
// U014. 시스템 상세 조회
const GET_OS_IP_DETAIL = 'sysMngt/GET_OS_IP_DETAIL';
const GET_OS_IP_DETAIL_SUCCESS = 'sysMngt/GET_OS_IP_DETAIL_SUCCESS';
const GET_OS_IP_DETAIL_FAILURE = 'sysMngt/GET_OS_IP_DETAIL_FAILURE';
// U045. 오류 처리 현황 문서 구분 리스트
const GET_SERVICE_NM_LIST = 'sysMngt/GET_SERVICE_NM_LIST';
const GET_SERVICE_NM_LIST_SUCCESS = 'sysMngt/GET_SERVICE_NM_LIST_SUCCESS';
const GET_SERVICE_NM_LIST_FAILURE = 'sysMngt/GET_SERVICE_NM_LIST_FAILURE';
// U046. 오류 처리 현황 시스템 구분 리스트
const GET_DOC_NM_LIST = 'sysMngt/GET_DOC_NM_LIST';
const GET_DOC_NM_LIST_SUCCESS = 'sysMngt/GET_DOC_NM_LIST_SUCCESS';
const GET_DOC_NM_LIST_FAILURE = 'sysMngt/GET_DOC_NM_LIST_FAILURE';
// U073. 오류 처리 현황 게시판 리스트 엑셀다운
const EXCEL_ERROR_HANDLING_LIST = 'sysMngt/EXCEL_ERROR_HANDLING_LIST';
const EXCEL_ERROR_HANDLING_LIST_SUCCESS = 'sysMngt/EXCEL_ERROR_HANDLING_LIST_SUCCESS';
const EXCEL_ERROR_HANDLING_LIST_FAILURE = 'sysMngt/EXCEL_ERROR_HANDLING_LIST_FAILURE';

// 0. Response 초기화
export const initSystemMngtResp = createAction(INIT_SYSTEM_MNGT_RESP);
export const initErrorHandlingListResp = createAction(INIT_ERROR_HANDLING_LIST_RESP);
export const initErrorHandlingDetailViewResp = createAction(INIT_ERROR_HANDLING_DETAIL_VIEW_RESP);
export const initCompanyListResp = createAction(INIT_COMPANY_LIST_RESP);
export const initInsertCustomIpInfoResp = createAction(INIT_INSERT_CUSTOM_IP_INFO_RESP);
export const initSaveCustomSysInfoResp = createAction(INIT_SAVE_CUSTOM_SYS_INFO_RESP);
export const initOsIpDetailResp = createAction(INIT_OS_IP_DETAIL_RESP);
export const initServiceNmListResp = createAction(GET_SERVICE_NM_LIST);
export const initDocNmListResp = createAction(GET_DOC_NM_LIST);
export const initExcelErrorHandlingListResp = createAction(INIT_EXCEL_ERROR_HANDLING_LIST_RESP);

// U009. 오류 처리 현황 게시판 리스트
export const getErrorHandlingList = createAction(GET_ERROR_HANDLING_LIST, (reqParam) => reqParam);
// U010. 오류 처리 현황 게시판 상세보기
export const getErrorHandlingDetailView = createAction(GET_ERROR_HANDLING_DETAIL_VIEW, (errSeq) => errSeq);
// U011. 이용중인 (유통사) 서비스 리스트
export const getCompanyList = createAction(GET_COMPANY_LIST, (usCode) => usCode);
// U012. 시스템 등록
export const insertCustomIpInfo = createAction(INSERT_CUSTOM_IP_INFO, (resultList) => resultList);
// U013. 시스템 수정(등록 , 수정, 삭제)
export const saveCustomSysInfo = createAction(SAVE_CUSTOM_SYS_INFO, (resultList) => resultList);
// U014. 시스템 상세 조회
export const getOsIpDetail = createAction(GET_OS_IP_DETAIL);
// U045. 오류 처리 현황 문서 구분 리스트
export const getServiceNmList = createAction(GET_SERVICE_NM_LIST);
// U046. 오류 처리 현황 시스템 구분 리스트
export const getDocNmList = createAction(GET_DOC_NM_LIST);
// U073. 오류 처리 현황 게시판 리스트 엑셀다운
export const excellErrorHandlingList = createAction(EXCEL_ERROR_HANDLING_LIST);

const getErrorHandlingListSaga = createRequestSaga(GET_ERROR_HANDLING_LIST, apiSysMngt.getErrorHandlingList);
const getErrorHandlingDetailViewSaga = createRequestSaga(
  GET_ERROR_HANDLING_DETAIL_VIEW,
  apiSysMngt.getErrorHandlingDetailView
);
const getCompanyListSaga = createRequestSaga(GET_COMPANY_LIST, apiSysMngt.getCompanyList);
const insertCustomIpInfoSaga = createRequestSaga(INSERT_CUSTOM_IP_INFO, apiSysMngt.insertCustomIpInfo);
const saveCustomSysInfoSaga = createRequestSaga(SAVE_CUSTOM_SYS_INFO, apiSysMngt.saveCustomSysInfo);
const getOsIpDetailSaga = createRequestSaga(GET_OS_IP_DETAIL, apiSysMngt.getOsIpDetail);
const getServiceNmListSaga = createRequestSaga(GET_SERVICE_NM_LIST, apiSysMngt.getServiceNmList);
const getDocNmListSaga = createRequestSaga(GET_DOC_NM_LIST, apiSysMngt.getDocNmList);
const excellErrorHandlingListSaga = createRequestSaga(EXCEL_ERROR_HANDLING_LIST, apiSysMngt.excellErrorHandlingList);

// apiSystemMngtSaga
export function* apiSystemMngtSaga() {
  yield takeLatest(GET_ERROR_HANDLING_LIST, getErrorHandlingListSaga);
  yield takeLatest(GET_ERROR_HANDLING_DETAIL_VIEW, getErrorHandlingDetailViewSaga);
  yield takeLatest(GET_COMPANY_LIST, getCompanyListSaga);
  yield takeLatest(INSERT_CUSTOM_IP_INFO, insertCustomIpInfoSaga);
  yield takeLatest(SAVE_CUSTOM_SYS_INFO, saveCustomSysInfoSaga);
  yield takeLatest(GET_OS_IP_DETAIL, getOsIpDetailSaga);
  yield takeLatest(GET_SERVICE_NM_LIST, getServiceNmListSaga);
  yield takeLatest(GET_DOC_NM_LIST, getDocNmListSaga);
  yield takeLatest(EXCEL_ERROR_HANDLING_LIST, excellErrorHandlingListSaga);
}

const initialState = {
  getErrorHandlingListResp: null,
  getErrorHandlingDetailViewResp: null,
  getCompanyListResp: null,
  insertCustomIpInfoResp: null,
  saveCustomSysInfoResp: null,
  getOsIpDetailResp: null,
  getServiceNmListResp: null,
  getDocNmListResp: null,
  excelErrorHandlingListResp: null,
};

const apiSystemMngtResp = handleActions(
  {
    // 0. Response 초기화
    [INIT_SYSTEM_MNGT_RESP]: (state, action) => ({
      getErrorHandlingListResp: null,
      getErrorHandlingDetailViewResp: null,
      getCompanyListResp: null,
      insertCustomIpInfoResp: null,
      saveCustomSysInfoResp: null,
      getOsIpDetailResp: null,
      getServiceNmListResp: null,
      getDocNmListResp: null,
      excelErrorHandlingListResp: null,
    }),
    [INIT_ERROR_HANDLING_LIST_RESP]: (state, action) => ({
      ...state,
      getErrorHandlingListResp: null,
    }),
    [INIT_ERROR_HANDLING_DETAIL_VIEW_RESP]: (state, action) => ({
      ...state,
      getErrorHandlingDetailViewResp: null,
    }),
    [INIT_COMPANY_LIST_RESP]: (state, action) => ({
      ...state,
      getCompanyListResp: null,
    }),
    [INIT_INSERT_CUSTOM_IP_INFO_RESP]: (state, action) => ({
      ...state,
      insertCustomIpInfoResp: null,
    }),
    [INIT_SAVE_CUSTOM_SYS_INFO_RESP]: (state, action) => ({
      ...state,
      saveCustomSysInfoResp: null,
    }),
    [INIT_OS_IP_DETAIL_RESP]: (state, action) => ({
      ...state,
      getOsIpDetailResp: null,
    }),
    [INIT_SERVICE_NM_LIST_RESP]: (state, action) => ({
      ...state,
      getServiceNmListResp: null,
    }),
    [INIT_DOC_NM_LIST_RESP]: (state, action) => ({
      ...state,
      getDocNmListResp: null,
    }),
    [INIT_EXCEL_ERROR_HANDLING_LIST_RESP]: (state, action) => ({
      ...state,
      excelErrorHandlingListResp: null,
    }),
    // U009. 오류 처리 현황 게시판 리스트
    [GET_ERROR_HANDLING_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getErrorHandlingListResp: action.payload,
    }),
    [GET_ERROR_HANDLING_LIST_FAILURE]: (state, action) => ({
      ...state,
      getErrorHandlingListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U010. 오류 처리 현황 게시판 상세보기
    [GET_ERROR_HANDLING_DETAIL_VIEW_SUCCESS]: (state, action) => ({
      ...state,
      getErrorHandlingDetailViewResp: action.payload,
    }),
    [GET_ERROR_HANDLING_DETAIL_VIEW_FAILURE]: (state, action) => ({
      ...state,
      getErrorHandlingDetailViewResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U011. 이용중인 (유통사) 서비스 리스트
    [GET_COMPANY_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getCompanyListResp: action.payload,
    }),
    [GET_COMPANY_LIST_FAILURE]: (state, action) => ({
      ...state,
      getCompanyListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U012. 시스템 등록
    [INSERT_CUSTOM_IP_INFO_SUCCESS]: (state, action) => ({
      ...state,
      insertCustomIpInfoResp: action.payload,
    }),
    [INSERT_CUSTOM_IP_INFO_FAILURE]: (state, action) => ({
      ...state,
      insertCustomIpInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U013. 시스템 수정(등록 , 수정, 삭제)
    [SAVE_CUSTOM_SYS_INFO_SUCCESS]: (state, action) => ({
      ...state,
      saveCustomSysInfoResp: action.payload,
    }),
    [SAVE_CUSTOM_SYS_INFO_FAILURE]: (state, action) => ({
      ...state,
      saveCustomSysInfoResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U014. 시스템 상세 조회
    [GET_OS_IP_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      getOsIpDetailResp: action.payload,
    }),
    [GET_OS_IP_DETAIL_FAILURE]: (state, action) => ({
      ...state,
      getOsIpDetailResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U045. 오류 처리 현황 문서 구분 리스트
    [GET_SERVICE_NM_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getServiceNmListResp: action.payload,
    }),
    [GET_SERVICE_NM_LIST_FAILURE]: (state, action) => ({
      ...state,
      getServiceNmListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U046. 오류 처리 현황 시스템 구분 리스트
    [GET_DOC_NM_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getDocNmListResp: action.payload,
    }),
    [GET_DOC_NM_LIST_FAILURE]: (state, action) => ({
      ...state,
      getDocNmListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U046. 오류 처리 현황 시스템 구분 리스트
    [EXCEL_ERROR_HANDLING_LIST_SUCCESS]: (state, action) => ({
      ...state,
      excelErrorHandlingListResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [EXCEL_ERROR_HANDLING_LIST_FAILURE]: (state, action) => ({
      ...state,
      excelErrorHandlingListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
  },
  initialState
);

export default apiSystemMngtResp;
